module.exports = __webpack_public_path__ + "static/media/compensation.c20a0168.svg";